import { required } from "@homebound/form-state";
import { GuidedChangeEventStep, GuidedChangeType } from "src/routes/projects/change-events/guided/utils";
import { SelectOptionStep } from "src/routes/projects/change-events/guided/workflows/addOnBookOption/2.SelectOptionStep";
import { reviewImpactStep, reviewStep } from "src/routes/projects/change-events/guided/workflows/sharedSteps";
import { defineWorkflow } from "src/routes/projects/change-events/guided/workflows/types";

// Form shape for the Add On-Book Option workflow.
export type AddOnBookOptionFormInput = { selectedOptionId?: string | null };

export const addOnBookOptionWorkflow = defineWorkflow<AddOnBookOptionFormInput>({
  changeType: GuidedChangeType.AddOnBookOption,
  formConfig: { selectedOptionId: { type: "value", rules: [required] } },
  steps: [
    {
      value: GuidedChangeEventStep.SelectOption,
      label: "Select Option",
      isComplete: (form) => !!form.selectedOptionId.value,
      render: (form) => <SelectOptionStep formState={form} />,
    },
    reviewImpactStep(),
    reviewStep(),
  ],
  useActions: () => {
    return {
      // TODO: submit the change event for the add-on-book-option flow.
      onSubmit: async () => {},
    };
  },
});
